import { styled } from "@mui/material/styles";

export const RowLayout = styled("div")({
  marginBottom: 10,
  marginTop: 10,
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
});

export const ColLayout = styled("div")({
  marginBottom: 10,
  marginTop: 20,
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
});

export const StyledModalDiv = styled("div")(({ theme }) => ({
  position: "absolute",
  width: 400,
  backgroundColor: theme.palette.background.paper,
  border: "2px solid #000",
  boxShadow: theme.shadows[5],
  padding: theme.spacing(2, 4, 3),
  textAlign: "center",
}));
